<template>
    <div style="height: 100%;">
        <el-row :gutter="20" class="container">
                <!-- 右边主要区 -->
                <el-col :span="24" :xs="24" class="container" style="flex-direction: column;border-width: 0;padding-top: 25px;">
                    <!-- 右边头部搜索区 -->
                    <el-form :model="queryParams.param" ref="queryForm" :inline="true" label-position="right" v-show="showSearch" label-width="110px">
                                <!-- 提供商名称 -->
                                <el-form-item :label="columnInfo.providerName.label" prop="providerName">
                                        <el-input v-model="queryParams.param.providerName" placeholder="请输入内容" size="small" clearable @keyup.enter.native="clickSearch"></el-input>
                                </el-form-item>
                                <!-- 协议类型 -->
                                <el-form-item :label="columnInfo.protocolType.label" prop="protocolType">
                                        <enum-dict-select v-model="queryParams.param.protocolType" module-name="data" dict-code="protocolType" placeholder="请选择" size="small" clearable/>
                                </el-form-item>
                                <!-- 接口基础地址 -->
                                <el-form-item :label="columnInfo.baseUrl.label" prop="baseUrl">
                                        <el-input v-model="queryParams.param.baseUrl" placeholder="请输入内容" size="small" clearable @keyup.enter.native="clickSearch"></el-input>
                                </el-form-item>
                                <!-- 接口密钥 -->
                                <el-form-item :label="columnInfo.apiKey.label" prop="apiKey">
                                        <el-input v-model="queryParams.param.apiKey" placeholder="请输入内容" size="small" clearable @keyup.enter.native="clickSearch"></el-input>
                                </el-form-item>
                                <!-- 模型名称 -->
                                <el-form-item :label="columnInfo.modelName.label" prop="modelName">
                                        <el-input v-model="queryParams.param.modelName" placeholder="请输入内容" size="small" clearable @keyup.enter.native="clickSearch"></el-input>
                                </el-form-item>
                                <!-- 是否默认 -->
                                <el-form-item :label="columnInfo.isDefault.label" prop="isDefault">
                                        <enum-dict-select v-model="queryParams.param.isDefault" module-name="data" dict-code="binary" placeholder="请选择" size="small" clearable/>
                                </el-form-item>
                                 <!-- 描述 -->
                                 <el-form-item :label="columnInfo.description.label" prop="description">
                                        <el-input v-model="queryParams.param.description" placeholder="请输入内容" size="small" clearable @keyup.enter.native="clickSearch"></el-input>
                                 </el-form-item>
                                 <!-- 状态 -->
                                 <el-form-item :label="columnInfo.state.label" prop="state">
                                        <enum-dict-select v-model="queryParams.param.state" module-name="data" dict-code="state"  placeholder="请选择" size="small" clearable/>
                                 </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-search" size="small" @click="clickSearch">搜索</el-button>
                            <el-button icon="el-icon-refresh" size="small" @click="clickReset">重置</el-button>
                        </el-form-item>
                    </el-form>
                    <!-- 右边中部功能区 -->
                    <el-row :gutter="10" style="margin-bottom:13px;margin-right: 1px">
                        <el-col :span="1.5">
                            <el-button
                                    type="primary"
                                    plain
                                    icon="el-icon-plus"
                                    size="small"
                                    @click="clickAdd"
                                    v-permissionDisabled="'data:modelConfig:create'"
                            >新增</el-button>
                        </el-col>
                        <el-col :span="1.5">
                            <excel-import-plus title="模型配置表" module-name="data" table-name="modelConfig" :permission-code="'data:modelConfig:import'"></excel-import-plus>
                        </el-col>
                        <el-col :span="1.5">
                            <excel-export-plus file-name="模型配置表" module-name="data" table-name="modelConfig" :select-list="selectList" :permission-code="'data:modelConfig:export'"></excel-export-plus>
                        </el-col>
                        <el-col :span="1.5">
                            <model-config-export-plus
                                button-text="添加 Claude Code"
                                button-type="success"
                                export-type="claude-code"
                                :select-list="selectList"
                            />
                        </el-col>
                        <el-col :span="1.5">
                            <model-config-export-plus
                                button-text="添加 OpenCode"
                                button-type="warning"
                                export-type="opencode"
                                :select-list="selectList"
                            />
                        </el-col>
                        <right-toolbar-plus :showSearch.sync="showSearch" @queryTable="handleTableSearch"
                                            :columnInfo="columnInfo" @redoTableLayout="redoTableLayout"></right-toolbar-plus>
                    </el-row>
                    <!-- 右边中部表格区 -->
                    <div class="main">
                        <div class="table">
                            <el-table border ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
                                      @selection-change="handleSelectionChange" height="100%" :header-cell-style="{background:'#ECF5FF'}">
                                <el-table-column align="center" type="selection" width="55"/>
                                        <!-- 提供商名称 -->
                                        <af-table-column align="center" prop="providerName" :label="columnInfo.providerName.label" v-if="columnInfo.providerName.visible">
                                        </af-table-column>
                                        <!-- 协议类型 -->
                                        <af-table-column align="center" prop="protocolType" :label="columnInfo.protocolType.label" v-if="columnInfo.protocolType.visible">
                                             <template v-slot="scope">
                                                   <enum-dict-label v-model="scope.row.protocolType" dict-code="protocolType" module-name="data" show-tag></enum-dict-label>
                                             </template>
                                        </af-table-column>
                                        <!-- 接口基础地址 -->
                                        <af-table-column align="center" prop="baseUrl" :label="columnInfo.baseUrl.label" v-if="columnInfo.baseUrl.visible">
                                        </af-table-column>
                                        <!-- 接口密钥 -->
                                        <af-table-column align="center" prop="apiKey" :label="columnInfo.apiKey.label" v-if="columnInfo.apiKey.visible">
                                        </af-table-column>
                                        <!-- 模型名称 -->
                                        <af-table-column align="center" prop="modelName" :label="columnInfo.modelName.label" v-if="columnInfo.modelName.visible">
                                        </af-table-column>
                                        <!-- 是否默认 -->
                                        <af-table-column align="center" prop="isDefault" :label="columnInfo.isDefault.label" v-if="columnInfo.isDefault.visible">
                                             <template v-slot="scope">
                                                   <enum-dict-label v-model="scope.row.isDefault" dict-code="binary" module-name="data" show-tag></enum-dict-label>
                                             </template>
                                        </af-table-column>
                                        <!-- 描述 -->
                                        <af-table-column align="center" prop="description" :label="columnInfo.description.label" v-if="columnInfo.description.visible">
                                        </af-table-column>
                                        <!-- 状态 -->
                                        <af-table-column align="center" prop="state" :label="columnInfo.state.label" v-if="columnInfo.state.visible">
                                             <template v-slot="scope">
                                                   <enum-dict-label v-model="scope.row.state" dict-code="state" module-name="data" show-tag></enum-dict-label>
                                             </template>
                                        </af-table-column>
                                <!-- 操作列 -->
                                <el-table-column align="center" label="操作" width="255" fixed="right">
                                    <template v-slot="scope">
                                        <el-button @click="clickEdit(scope.row)" type="primary" size="mini" v-permissionDisabled="'data:modelConfig:update'">编辑</el-button>
                                        <el-button @click="clickDel(scope.row)" type="danger" size="mini" v-permissionDisabled="'data:modelConfig:remove'">删除</el-button>
                                        <table-more-button :row="scope.row" :button-props="moreButtonProps" @handleCommand="handleCommand"></table-more-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                    <!-- 右边底部分页区 -->
                    <div style="height: 40px;margin-bottom: 0.1rem;">
                        <pagination-plus :totalCount="totalCount"
                                         :param="queryParams"
                                         :pageSizes="pageSizes"
                                         :selectList="selectList"
                                         module-name="data"
                                         table-name="modelConfig"
                                         :del-all-permission-code="'data:modelConfig:removes'"
                                         :state-permission-code="'data:modelConfig:state'"
                                         @handleTableRefresh="handleTableSearch"/>
                    </div>
                </el-col>
        </el-row>
        <!-- 弹出层组件 -->
        <modelConfigForm/>
    </div>
</template>

<script>
    /**
     * 模型配置表主页面 （与自定义组件之间请遵循MVVM架构）
     * @author PeterLee
     * @since 2026-05-21
     */
    import modelConfigForm from "./ModelConfigForm"
    import {mapState, mapMutations, mapActions} from "vuex";
    import {registerStore,unregisterStore} from "@/utils/common";
    import modelConfigDataProvider from "./ModelConfigDataProvider";

    export default {
        components: {
            // 表单弹出组件
            modelConfigForm
        },
        data() {
            return {
                // 每页条数选项（分页控件）
                pageSizes: [10, 20, 40, 80],
                // 批量操作选中list（分页控件）
                selectList: [],
                // 展示搜索区（right-toolbar）
                showSearch: false,
                // 导出loading
                exportLoading: false,
            }
        },
        computed: {
            ...mapState({
                // 表格数据
                tableData: state => state.data.modelConfig.tableData,
                // 下拉选项
                options: state => state.data.modelConfig.options,
                // 共有数据条数（分页控件）
                totalCount: state => state.data.modelConfig.totalCount,
                // 列信息
                columnInfo: state => state.data.modelConfig.columnInfo,
                // 查询参数
                queryParams: state => state.data.modelConfig.queryParams,
                // 时间范围
                dateRange: state => state.data.modelConfig.dateRange,
                // 更多按钮信息
                moreButtonProps: state => state.data.modelConfig.moreButtonProps,
            })
        },
        // 生命周期create函数
        created() {
            // 注册vuex模块
            registerStore('data','modelConfig',modelConfigDataProvider);
            // 创建时获取所有权限数据（分页查询）
            this.handleTableSearch();
            // 获取OptionList
            this.getOptionList();
        },
        // 生命周期销毁函数
        destroyed() {
            // 解绑vuex模块
            unregisterStore('data','modelConfig');
        },
        methods: {
            ...mapMutations({
                clickEdit: 'data/modelConfig/clickEdit',
                clickAdd: 'data/modelConfig/clickAdd',
            }),
            ...mapActions({
                clickDel: 'data/modelConfig/handleDel',
                handleTableSearch: 'data/modelConfig/handleTableSearch',
                getOptionList: 'data/modelConfig/getOptionList',
            }),
            /** 重置按钮点击（搜索区） */
            clickReset() {
                for (let key of Object.keys(this.dateRange)) {
                    this.dateRange[key] = []
                }
                this.$refs['queryForm'].resetFields();
                this.handleTableSearch();
            },
            /** 搜索按钮点击（搜索区） */
            clickSearch() {
                this.queryParams.currPage = 1;
                this.handleTableSearch();
            },
            /** 处理选择改变（表格区） */
            handleSelectionChange(selectList) {
                this.selectList = selectList;
            },
            /** 重新计算表格（按钮区） */
            redoTableLayout() {
                // 数据加载完成后执行
                this.$nextTick(() => {
                    // 表格重新渲染
                    this.$refs.multipleTable.doLayout();
                });
            },
            /** 更多按钮方法处理（按钮区） */
            handleCommand(command,row) {
                // console.log(command)
                // console.log(row)
            },
        }
    }
</script>

<style lang="less" scoped>
    @import url('~@/assets/style/index.less');

    ::v-deep .el-form-item {
        margin-bottom: 18px;
    }
</style>
